import { useEffect } from "react";
import { SITE_ORIGIN } from "@/constants/contact";

// Lightweight SEO: title, meta description, canonical, OG, and optional FAQ schema.
export default function SEO({ title, description, path = "/", faq }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Rao Investment Solutions`
      : "Rao Investment Solutions — Financial & Wealth Solutions";
    document.title = fullTitle;

    // Canonical always points at the public domain, never localhost or a
    // preview host, so crawlers never index a non-public origin.
    const canonical = SITE_ORIGIN + path;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    let script = document.getElementById("faq-schema");
    if (faq && faq.length) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "faq-schema";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faq.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      });
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, faq]);

  return null;
}
